import React, { useRef, useEffect } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import useModalStore from "store/modals";
import { useAllPartySupMasts } from "http-hooks/partysupmast/usepartysupmast";

const SelectTransporters = ({
  value,
  onChange,
  placeholder = "Select Transporter",
  isDisabled = false,
  isRequired = false,
  isMulti = false,
  label = "Transporter",
  className = "",
  filters = {},
  showLabel = true,
  initialValue = null,
  showAddButton = true, // New prop to control plus button visibility
}) => {
  const hasInitialized = useRef(false);
  const { openModal } = useModalStore();
  
  const {
    isLoading: isLoadingAllTransportAccount,
    data: { data: allTransportAccounts } = [],
  } = useAllPartySupMasts({
    type: "T",
    level: 0,
    grplevel: 0,
    ag_status: 1,
    noPagination: true,
    ...filters,
  });

  // Handle initial value selection
  useEffect(() => {
    if (initialValue && !hasInitialized.current && allTransportAccounts?.length > 0 && onChange) {
      try {
        if (!initialValue.ps_Id) {
          throw new Error('initialValue must contain ps_Id field');
        }
        
        const matchingOption = allTransportAccounts.find(option => 
          option.ps_Id === initialValue.ps_Id
        );
        
        if (matchingOption) {
          onChange(matchingOption);
          hasInitialized.current = true;
        }
      } catch (error) {
        console.error('SelectTransporters initialValue error:', error);
        throw error;
      }
    }
  }, [initialValue, allTransportAccounts, onChange]);

  const handleAddNew = () => {
    openModal('transporter');
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new transporter"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={allTransportAccounts}
        getOptionValue={(option) => option?.ps_Id}
        getOptionLabel={(option) => option?.name}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoadingAllTransportAccount}
        isRequired={isRequired}
        isMulti={isMulti}
        label={label}
        className={className}
        showLabel={false}
        isClearable={true}
        isSearchable={true}
      />
      {!showLabel && showAddButton && !isDisabled && (
        <button
          type="button"
          onClick={handleAddNew}
          className="absolute top-0 right-0 h-10 w-10 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
          title="Add new transporter"
        >
          <PlusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SelectTransporters; 